<template>
  <div>
    <div
      v-if="showLoading"
      wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
    >
      <div
        class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"
      ></div>
      <h2 class="text-center text-white text-xl font-semibold">Loading...</h2>
      <p class="w-1/3 text-center text-white">
        if it takes more than 5 seconds, please refresh the page.
      </p>
    </div>

    <div class="top-hero2 flex justify-center">
      <div class="w-full sm:w-8/12 sm:mt-8 rounded-lg">
        <div class="overflow-hidden mt-12 sm:mt-0">
          <div class="w-full">
            <v-toolbar
              color="#01579B"
              class="block sm:hidden top-hero6"
              dark
              flat
            >
              <v-toolbar-title class="text-lg">News</v-toolbar-title>
              <input
                v-model="search"
                type="search"
                name="serch"
                placeholder="Search News by title or description"
                class="ml-4 shadow bg-white mt-1 h-10 w-8/12 px-5 pr-10 rounded-full text-sm focus:outline-none"
              />
            </v-toolbar>

            <div
              class="hidden sm:block text-center mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl"
            >
              <p
                class="text-3xl font-extrabold text-white tracking-tight sm:text-4xl"
              >
                News
              </p>

              <div class="text-gray-600">
                <input
                  v-model="search"
                  type="search"
                  name="serch"
                  placeholder="Search News by title or description"
                  class="shadow bg-white h-10 w-full px-5 pr-10 rounded-full text-sm focus:outline-none"
                />
              </div>
            </div>

            <div
              class="mt-4 mx-auto max-w-md px-4 grid gap-6 sm:max-w-lg sm:px-6 lg:px-8 lg:grid-cols-3 lg:max-w-7xl"
            >
              <div
                v-for="post in filterPosts"
                :key="post.id"
                class="flex flex-col shadow-lg overflow-hidden"
              >
                <div class="flex-shrink-0">
                  <img
                    class="h-48 w-full object-cover bg-white"
                    :src="post.images.post_image_path"
                    alt=""
                  />
                </div>

                <div class="flex-1 bg-white p-3 flex flex-col justify-between">
                  <div class="flex-1">
                    <a @click="redirect(post)" class="cursor-pointer block">
                      <p class="text-2xl font-semibold text-blue-800 uppercase">
                        <span class="text-base text-gray-300">
                          {{ dateFormat(post.created_at) }} </span
                        ><br />
                        {{ post.title }}<br />
                        <span class="text-base text-gray-300">
                          {{ post.category.name }}
                        </span>
                      </p>
                      <p class="mt-3 text-lg text-gray-600">
                        {{ post.description }}
                      </p>
                    </a>
                  </div>

                  <div class="mt-4">
                    <button
                      @click="redirect(post)"
                      type="button"
                      class="uppercase inline-flex items-center px-6 py-2 border border-indigo-600 text-sm leading-4 font-medium shadow-sm text-indigo-600 hover:text-gray-50 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Read More
                    </button>

                    <div class="float-right flex">
                      <a
                        target="_blank"
                        href="https://www.linkedin.com/in/nicolaburger"
                        class="ml-2 cursor-pointer text-gray-400 hover:text-gray-500"
                      >
                        <img
                          class="w-7 h-7 rounded-full"
                          src="https://img.icons8.com/color/48/000000/linkedin.png"
                        />
                      </a>
                      <a
                        class="cursor-pointer text-gray-400 hover:text-gray-500"
                      >
                        <ShareNetwork
                          network="facebook"
                          :url="'https://www.homesby360.com/news/' + post.slug"
                          :title="post.title"
                          :description="post.description"
                          :quote="post.title"
                        >
                          <img
                            class="w-7 h-7 rounded-full"
                            src="https://img.icons8.com/fluency/48/000000/facebook.png"
                          />
                        </ShareNetwork>
                      </a>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/homesby360"
                        class="cursor-pointer text-gray-400 hover:text-gray-500"
                      >
                        <img
                          class="w-7 h-7 rounded-full"
                          src="https://img.icons8.com/color/48/000000/instagram-new--v1.png"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="hidden sm:block" v-if="posts.length > 0">
      <footer-links></footer-links>
    </div>  -->
        <div class="block sm:hidden my-16"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "News",
  data() {
    return {
      loading: true,
      showLoading: true,
      posts: [],
      checked: "",
      search: "",
      response: false,
      dateSelected: new Date().toISOString().substr(0, 10)
    };
  },

  created() {
    this.getPosts();
  },

  computed: {
    filterPosts() {
      if (this.search == "") {
        return this.posts;
      } else {
        return this.posts.filter(user => {
          return (
            user.title.toLowerCase().includes(this.search.toLowerCase()) ||
            user.description.toLowerCase().includes(this.search.toLowerCase())
          );
        });
      }
    }
  },

  methods: {
    orderPosts() {
      // let value = this.posts.reduce((acc, shot) => acc = acc > shot.counter ? acc : shot.counter, 0);

      window.axios.get("/api/filterPosts").then(res => {
        this.posts = res.data;
      });
    },

    dateFormat(value) {
      const format = "LL";
      return moment(value).format(format);
    },

    searching() {
      window.axios
        .post("/api/postRes", {
          queryResult: this.search
        })
        .then(res => {
          this.response = true;
          this.posts = res.data;
        });
    },

    getPosts() {
      window.axios.get("/api/posts").then(res => {
        this.posts = res.data;
        this.showLoading = false;
      });
    },

    redirect(post) {
      this.$router.push({ name: "Post", params: { id: post.slug } });
    }
  }
};
</script>
